/**
 * The server's catalog-path pattern for a claim-bar field key (`CATALOG_PATH_PATTERN` in
 * `claim_fields_config/schemas/claim_fields.py`). The generated contract publishes it on `field_key`,
 * and `claimBarFieldKey.test.ts` fails if the two part.
 */
export const CATALOG_PATH_PATTERN = '^(claim|policy)\\.(api|configured_fields)\\.[a-z0-9_]+(?:\\.[a-z0-9_]+)*$';

const CATALOG_PATH_RE = new RegExp(CATALOG_PATH_PATTERN);

export type CatalogNamespace = 'api' | 'configured_fields';

/** A catalog path's namespace, or null for a built-in field. `configured_fields` is what the CONFIGURED badge marks. */
export const getCatalogNamespace = (fieldKey: string): CatalogNamespace | null =>
  (CATALOG_PATH_RE.exec(fieldKey)?.[2] as CatalogNamespace | undefined) ?? null;
